import './frontend.scss';
document.addEventListener('DOMContentLoaded', function() {
    // Get all accordions on the page
    var accordions = document.querySelectorAll('.wp-block-ps-s-custom-gutenberg-components-ps-s-accordion');

    accordions.forEach(function(accordion) {
        // Get all accordion slides in the current accordion
        var slides = accordion.querySelectorAll('[class^="ps-s-accordion-slide-"]');

        slides.forEach(function(slide, index) {
            // Get the heading and content divs
            var heading = slide.querySelector('.ps-s-accordion-heading');
            var content = slide.querySelector('.ps-s-accordion-content');

            // Hide the content div and set ARIA labels on load
            content.style.display = 'none';
            heading.setAttribute('aria-expanded', 'false');
            content.setAttribute('aria-hidden', 'true');

            // Add a click event listener to the heading
            heading.addEventListener('click', function() {
                var isExpanded = heading.getAttribute('aria-expanded') === 'true';

                // Toggle the content div and ARIA labels
                content.style.display = isExpanded ? 'none' : 'block';
                heading.setAttribute('aria-expanded', !isExpanded);
                content.setAttribute('aria-hidden', isExpanded);
            });

            // Add a keydown event listener to the heading for keyboard accessibility
            heading.addEventListener('keydown', function(event) {
                // Check if the pressed key is Enter
                if (event.key === 'Enter' || event.keyCode === 13) {
                    // Prevent the default action to stop scrolling when space is pressed
                    event.preventDefault();

                    // Simulate a click event
                    heading.click();
                }
            });

            // Make the heading focusable.
            heading.setAttribute('tabindex', '0');
        });
    });
});
